import { Typography, Stack , Paper} from '@mui/material';
import React from 'react';
import { RenderPreferences, RenderWeeklySummary, RenderSummaryItemForDashboard} from './EMCRenderUtils.js' ;


const WeeklyDashboard = ({Summary}) => {
  // console.log ('User in profile', props.user);
  //console.log ('Weekly Summary', props.user.WeeklySummary);
  // user will have the following structure { {id:id}, {name:name}, {prefs:prefs}, {WeeklySummary:[]}, {AnnualSummary:summary}}
  
  const RenderWeeklyDashboard = ({SummaryList}) => {
    return(
      <>
      {SummaryList.map(SummaryItem =>  
            <Paper key={SummaryItem.id} elevation={1}> 
                <RenderSummaryItemForDashboard item={SummaryItem} type="Weekly" /> 
            </Paper> 
            )}
      </>
    );
  }

  return  (
          <>
            <RenderWeeklyDashboard SummaryList={Summary}/>
          </>
  );

}

export default WeeklyDashboard;